import { curry } from 'ramda';

import { EPaymentStatus } from '../../../services/billingPayments';
import { TThunkAction } from '../../../../common/types/thunk';
import { selectConfigValue } from '../../../selectors/config';
import { sleep } from '../../../../common/utils/sleep';
import { loadPublishTerms } from '../../publishTerms/loadPublishTerms';
import { checkServiceAfterCheckPaymentStatus } from '../../../actions/checkoutInfo';
import { selectLayoutOSType } from '../../../selectors/layout';

import { EPaymentStatusCheckType, CHANGE_PAYMENT_STATUS_ACTION } from './types';

export const processChangingCheckPaymentStatus = curry(
  (type: EPaymentStatusCheckType, status: EPaymentStatus): TThunkAction<Promise<void>> =>
    async (dispatch, getState, { isMicrofrontend }) => {
      const setStatusAction = CHANGE_PAYMENT_STATUS_ACTION[type];
      const isSuccess = status === EPaymentStatus.Succeeded;

      if (!isSuccess) {
        dispatch(setStatusAction(status));

        return;
      }

      const state = getState();
      const osType = selectLayoutOSType(state);
      const loadPublishTermsTimeout = selectConfigValue('loadPublishTermsAfterBuyPackageTimeout')(state);

      // в апках андроида для некоммерческих пользаков после покупки пакета
      // вызывается событие успешного пополнения баланса, а не покупки пакета
      // поэтому для osType android всегда перезапрашиваем услуги
      const isAndroidApp = !isMicrofrontend && osType === 'android';

      if (type === EPaymentStatusCheckType.Package || isAndroidApp) {
        await sleep(loadPublishTermsTimeout);

        await dispatch(loadPublishTerms());
      }

      dispatch(checkServiceAfterCheckPaymentStatus());
      dispatch(setStatusAction(null));
    },
);
